import React, { useState } from "react";
import { Lock, User, LogIn } from "lucide-react";

const VALID_ID = "Claudiu";
const VALID_PW = "Claudiu123";

export const Login = ({ onLogin }) => {
  const [id, setId] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setErr("");
    setTimeout(() => {
      if (id.trim() === VALID_ID && pw === VALID_PW) {
        localStorage.setItem("cls_auth", "1");
        onLogin();
      } else {
        setErr("ID sau parolă greșită");
        setLoading(false);
      }
    }, 350);
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
      style={{ background: "radial-gradient(1200px 600px at 50% -10%, #0e1a33 0%, #070b14 55%, #05080f 100%)" }}
      data-testid="login-screen"
    >
      {/* ambient grid glow */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.15]"
        style={{
          backgroundImage:
            "linear-gradient(#1e3a8a22 1px, transparent 1px), linear-gradient(90deg, #1e3a8a22 1px, transparent 1px)",
          backgroundSize: "44px 44px",
        }}
      />

      <form
        onSubmit={submit}
        data-testid="login-form"
        className="relative w-full max-w-[380px] rounded-2xl p-7 sm:p-8"
        style={{
          background: "linear-gradient(180deg, rgba(23,37,62,0.72) 0%, rgba(15,24,42,0.72) 100%)",
          border: "1px solid rgba(56,189,248,0.25)",
          backdropFilter: "blur(18px)",
          WebkitBackdropFilter: "blur(18px)",
          boxShadow: "0 0 60px -12px rgba(56,189,248,0.35), inset 0 1px 0 rgba(255,255,255,0.04)",
        }}
      >
        <div className="text-center mb-7">
          <h1
            className="font-display font-black tracking-[0.12em] text-2xl sm:text-[26px] leading-tight"
            style={{ color: "#38bdf8", textShadow: "0 0 18px rgba(56,189,248,0.55)" }}
            data-testid="login-title"
          >
            CLS LOGISTIC
          </h1>
          <p
            className="font-display font-bold tracking-[0.3em] text-sm mt-1"
            style={{ color: "#7dd3fc", textShadow: "0 0 14px rgba(56,189,248,0.4)" }}
          >
            ACTIV OFERTE
          </p>
        </div>

        <label className="block text-xs font-semibold tracking-[0.2em] text-slate-400 mb-2 uppercase">
          User ID
        </label>
        <div className="relative mb-5">
          <User className="w-4 h-4 text-sky-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <input
            value={id}
            onChange={(e) => setId(e.target.value)}
            autoFocus
            data-testid="login-id-input"
            className="w-full bg-[#0b1626]/80 border border-[#1e3350] focus:border-sky-500 rounded-lg pl-10 pr-3 py-3 text-base text-slate-100 placeholder:text-slate-600 outline-none transition-colors"
            placeholder="Introdu ID-ul"
          />
        </div>

        <label className="block text-xs font-semibold tracking-[0.2em] text-slate-400 mb-2 uppercase">
          Password
        </label>
        <div className="relative mb-6">
          <Lock className="w-4 h-4 text-sky-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <input
            type="password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submit(e)}
            data-testid="login-password-input"
            className="w-full bg-[#0b1626]/80 border border-[#1e3350] focus:border-sky-500 rounded-lg pl-10 pr-3 py-3 text-base text-slate-100 placeholder:text-slate-600 outline-none transition-colors"
            placeholder="••••••••••"
          />
        </div>

        {err && (
          <p className="text-red-400 text-sm font-semibold text-center mb-4" data-testid="login-error">
            ✖ {err}
          </p>
        )}

        <button
          type="submit"
          disabled={loading}
          data-testid="login-submit-button"
          className="w-full inline-flex items-center justify-center gap-2 py-3 rounded-lg font-bold text-base text-white transition-all disabled:opacity-60"
          style={{
            background: "linear-gradient(90deg, #0ea5e9 0%, #38bdf8 100%)",
            boxShadow: "0 8px 24px -6px rgba(56,189,248,0.6)",
          }}
        >
          <LogIn className="w-5 h-5" /> {loading ? "Se verifică…" : "Login"}
        </button>
      </form>
    </div>
  );
};
